import { Context } from "effect";
import type { Effect, Scope } from "effect";
import type { WorkerBindingsSnapshot } from "../../api/worker-bindings/model.ts";
import type { CatalogSession } from "../catalog/model.ts";

export class WorkerBindingsSessions extends Context.Service<WorkerBindingsSessions, {
  readonly open: Effect.Effect<CatalogSession<WorkerBindingsSnapshot>, never, Scope.Scope>;
}>()("workerstation/frontend/WorkerBindingsSessions") {}
